export default __webpack_public_path__ + "static/image-6-98a29db29272b2798ac54ee5cdbb3d6a.jpg";